export const backLinks = {
  'add-card': '/moj-nalog#platne-kartice',
  'add-card-so': '/racuni#trajni-nalog',
  'bills-standalone': '/racuni',
  'digital-services': '/digitalni-servisi',
  bills: '/racuni',
  default: '/pregled-usluga'
}
